import { Fragment } from "react";
import type { FieldTypes } from "../constants";
import { CustomField } from "./CustomField";
import type { CustomFieldProps } from "./CustomField";
import { LocationNotice } from "./LocationNotices/LocationNotice";
import { isPlatformLocationField } from "./LocationNotices/useCurrentUserLocationInfo";

type Props = Omit<CustomFieldProps, "fieldType" | "id" | "index">;

export interface Field extends Props {
  id: number;
  field_type: FieldTypes;
}

export interface CustomFieldsListProps {
  fields: Field[];
  indexUpdate?: number;
  shouldShowLocationNotices?: boolean;
}

// TODO: Remove shouldShowLocationNotices after a certain time period
// I am passing it here as props instead of checking the feature flag
// because CustomFieldsList is used in multiple places. Not just in Edit Profile page
export const CustomFieldsList = ({
  fields,
  indexUpdate = 0,
  shouldShowLocationNotices = false,
}: CustomFieldsListProps) => (
  <>
    {fields.map(({ id, field_type, ...props }, index) => (
      <Fragment key={`profile-custom-field-${id}`}>
        <CustomField
          index={indexUpdate + index}
          fieldType={field_type}
          {...props}
          dataTestId="profile-custom-field"
        />
        {isPlatformLocationField({
          field_type,
          platform_field: props.platform_field,
        }) &&
          shouldShowLocationNotices && <LocationNotice />}
      </Fragment>
    ))}
  </>
);
